export const SERVICE_AVAILABILITY_KEYS = [
  "viewer_360",
  "ai_photo_bg",
  "ai_customer_support",
  "facebook_crosspost",
  "list_boost",
  "priority_ranking",
  "meta_ads",
  "detailed_stats",
];

export const SERVICE_AVAILABILITY_LABELS = {
  viewer_360: "360° körbeforgatás",
  ai_photo_bg: "AI háttércsere",
  ai_customer_support: "AI ügyfélszolgálat",
  facebook_crosspost: "Facebook megosztás",
  list_boost: "Kiemelés listában",
  priority_ranking: "Kiemelt rangsorolás",
  meta_ads: "Meta hirdetés",
  detailed_stats: "Részletes statisztika",
};

export const DEFAULT_UNAVAILABLE_MESSAGE = "Jelenleg nem elérhető — fejlesztés alatt.";

export function normalizeServiceAvailability(raw) {
  const out = {};
  for (const key of SERVICE_AVAILABILITY_KEYS) {
    out[key] = { available: true, unavailable_message: "" };
  }
  if (!raw || typeof raw !== "object") return out;
  for (const key of SERVICE_AVAILABILITY_KEYS) {
    const entry = raw[key];
    if (entry == null) continue;
    if (typeof entry === "boolean") {
      out[key].available = entry;
      continue;
    }
    if (typeof entry === "object") {
      if ("available" in entry) out[key].available = !!entry.available;
      else if ("enabled" in entry) out[key].available = !!entry.enabled;
      const msg = String(entry.unavailable_message || entry.message || "").trim();
      if (msg) out[key].unavailable_message = msg.slice(0, 300);
    }
  }
  return out;
}

export function isServiceAvailable(config, key) {
  const flags = normalizeServiceAvailability(config?.service_availability);
  return flags[key]?.available !== false;
}

export function serviceUnavailableMessage(config, key) {
  const flags = normalizeServiceAvailability(config?.service_availability);
  const msg = String(flags[key]?.unavailable_message || "").trim();
  return msg || DEFAULT_UNAVAILABLE_MESSAGE;
}
